import  { useEffect } from 'react'
import { SurveyEngine_Models_BaseResponse, SurveyEngine_Models_WebTransferResponse } from '../../../api'

interface WebTransferProps {
  id: number,
  baseUrl: string | null
  OpenInNewWindow: boolean | null
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}

export const WebTransfer = (props: WebTransferProps) => {
  
  useEffect(() => {

    let response: SurveyEngine_Models_WebTransferResponse = {
      commandType: "WebTransfer",
      commandIndex: props.id,
    };
    props.callback(response);

    if (props.baseUrl) {
      window.onbeforeunload = null;
      window.onpagehide = null;
      props.OpenInNewWindow
        ? window.open(props.baseUrl, '_blank')
        // ? window.open(props.baseUrl, '_blank','height='+window.outerHeight+',width='+window.outerWidth)
        : window.open(props.baseUrl, '_parent')
    }

  }, [props])

  return <></>
}
